import axios from "axios"
const API_URL = process.env.VUE_APP_API;
import { router } from "../../../routes"
const moduleInitAuth = {
    state: () => ({
        site: "",
        sites: [],
        modules: [],

    }),
    mutations: {
        setSite(state, site) {
            localStorage.setItem("site", site)
            state.site = site
        },
        setSites(state, sites) {
            state.sites = sites
        },
        setModules(state, modules) {
            state.modules = modules
        },

    },
    actions: {
        initAuth({ commit, dispatch }) {
            let ga = localStorage.getItem("ga")
            let token = localStorage.getItem("token")
            commit("setToken", token)

            if (ga && token) {

                commit("setGa", ga)
                commit("setName", localStorage.getItem("name"))
                commit("setSurname", localStorage.getItem("surname"))
                commit("setId", localStorage.getItem("id"))
                dispatch("sites", { id: localStorage.getItem("id"), token: token })
                dispatch("modules", { id: localStorage.getItem("id"), token: token })


                const currentActiveURL = sessionStorage.currentActiveURL
                if (!currentActiveURL || currentActiveURL === "undefined" || currentActiveURL === "null") {
                    router.push("/")
                } else {
                    router.push(currentActiveURL)
                }


            } else {


                if (router.path == "/login")
                    router.push("/login")


                return false
            }
        },

        sites({ commit, dispatch }, data) {
            axios.get(`${API_URL}/UserSite/ListUserSites/` + data.id, {
                headers: {
                    'site': "genel",
                    'token': data.token
                }
            }).then(response => {


                let site = localStorage.getItem("site")
                if (site == null) {

                    if (response.data.length > 0)
                        site = response.data[0].slug
                    else
                        site = "genel"
                }

                commit("setSite", site)
                commit("setSites", response.data)
                localStorage.setItem("site", site)

            }).catch((err) => {
                if (err.response.status == 401) {
                    Swal.fire({
                        title: "Error!",
                        text: err.response.data,
                        icon: "error",
                        confirmButtonText: "Kapat"
                      });
                    commit("setMessage", err.response.data)
                    dispatch("logout")
                }
            })
        },
        modules({ commit }, data) {
            axios.get(`${API_URL}/UserModule/ListUserModules/` + data.id, {
                headers: {
                    'site': "genel",
                    'token': data.token
                }
            }).then(response => {


                let modules = {}

                $.each(response.data, (key, value) => {
                    modules[value.slug] = { isRead: value.isRead, isWrite: value.isWrite }

                })

                commit("setModules", modules)


            }).catch((err) => {
                if (err.response.status == 401) {
                    Swal.fire({
                        title: "Error!",
                        text: err.response.data,
                        icon: "error",
                        confirmButtonText: "Kapat"
                      });
                    store.commit("setMessage", err.response.data)
                    store.dispatch("logout")
                }
            })
        },
    },
    getters: {
        getSite(state) {
            return state.site
        },
        getSites(state) {
            return state.sites
        },
        getModules(state) {
            return state.modules
        },
    }

}

export default moduleInitAuth;


// WEBPACK FOOTER //
// ./src/store/Modules/initAuth/index.js